import React from "react";
import { Switch } from "@headlessui/react";

const Toggle = ({ enabled, onChange, label, disabled = false, size = "md" }) => {
  const sizeClasses = {
    sm: "h-5 w-9",
    md: "h-6 w-11",
    lg: "h-7 w-14",
  };

  const ballSizeClasses = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  };

  const translateClasses = {
    sm: enabled ? "translate-x-5" : "translate-x-1",
    md: enabled ? "translate-x-6" : "translate-x-1",
    lg: enabled ? "translate-x-8" : "translate-x-1",
  };

  return (
    <Switch.Group>
      <div className="flex items-center">
        <Switch
          checked={enabled}
          onChange={onChange}
          disabled={disabled}
          className={`
            ${enabled ? "bg-primary" : "bg-neutral-light dark:bg-neutral-dark"}
            ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
            relative inline-flex items-center rounded-full
            transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
            ${sizeClasses[size]}
          `}
        >
          <span
            aria-hidden="true"
            className={`
              ${translateClasses[size]}
              inline-block transform rounded-full bg-white transition-transform
              ${ballSizeClasses[size]}
            `}
          />
        </Switch>
        {label && (
          <Switch.Label className="ml-3 text-sm text-text dark:text-neutral-light">
            {label}
          </Switch.Label>
        )}
      </div>
    </Switch.Group>
  );
};

export default Toggle;
